import { useNavigate } from "react-router-dom";

import { PageContainer } from "@/features/ui";

import { useAuth } from "@/features/authentication";
import { SalesOrderForm } from "@/features/sales-orders";
import { apiOutletClient, getErrorMessage } from "@/features/shared";
import { useSnackbar } from "@/features/ui";

import { Button } from "@mui/material";

export const CreateSalesOrder = () => {
  const { outlet } = useAuth();
  const navigate = useNavigate();
  const { showSnackbar } = useSnackbar();

  const handleSubmit = async (formData) => {
    try {
      const { sellerId, ...payload } = formData;

      await apiOutletClient.post("sales-orders", payload, {
        headers: {
          "Outlet-Id": sellerId,
        },
      });
      navigate(-1);
    } catch (error) {
      showSnackbar(
        getErrorMessage(error, "Gagal membuat pesanan penjualan")
      );
    }
  };

  return (
    <PageContainer maxWidth="xl" title="Buat Pesanan Penjualan">
      <SalesOrderForm
        onSubmit={handleSubmit}
        defaultValues={{
          seller: outlet,
        }}
        renderActionButton={({ isSubmitting }) => (
          <Button
            fullWidth
            type="submit"
            variant="contained"
            loading={isSubmitting}
          >
            Buat Penjualan
          </Button>
        )}
      />
    </PageContainer>
  );
};
